export const validateProduct = (values) => {
  const errors = {};
  const isBaseProduct = [1, 2, 7].includes(
    parseInt(values.product_types_id, 10)
  );
  const isProbeProduct = [3, 4, 5, 6, 7].includes(
    parseInt(values.product_types_id, 10)
  );

  // Common validations
  if (!values.product_types_id) {
    errors.product_types_id = "validation_required_field";
  }

  // Registration number validation - XXXX-XXX or XXXX-XXXX format
  if (!values.regnumber) {
    errors.regnumber = "validation_required_field";
  } else if (!/^[A-Za-z0-9]{4}-[A-Za-z0-9]{3,4}$/.test(values.regnumber)) {
    errors.regnumber = "validation_regnumber_format";
  }

  // Status validation
  if (!values.status) {
    errors.status = "validation_required_field";
  } else if (values.status.length !== 1) {
    errors.status = "validation_status_length";
  }

  // Company validation
  if (!values.companies_id) {
    errors.companies_id = "validation_required_field";
  }

  // Probe type validation
  if (!values.probe_type) {
    errors.probe_type = "validation_required_field";
  } else if (values.probe_type.length > 10) {
    errors.probe_type = "validation_probe_type_length";
  }

  // Base product specific validations
  if (isBaseProduct) {
    if (!values.baseid) {
      errors.baseid = "validation_required_field";
    } else if (values.baseid.length !== 4) {
      errors.baseid = "validation_baseid_length";
    }

    if (!values.imeei) {
      errors.imeei = "validation_required_field";
    } else if (values.imeei.length !== 15) {
      errors.imeei = "validation_imeei_length";
    }

    if (!values.sim) {
      errors.sim = "validation_required_field";
    } else if (values.sim.length !== 20) {
      errors.sim = "validation_sim_length";
    }

    if (!values.sim_id) {
      errors.sim_id = "validation_required_field";
    }
  }

  // Probe product specific validations
  if (isProbeProduct) {
    if (!values.probeid) {
      errors.probeid = "validation_required_field";
    } else if (!Number.isInteger(Number(values.probeid))) {
      errors.probeid = "validation_probeid_integer";
    }

    if (!values.probelength) {
      errors.probelength = "validation_required_field";
    } else if (!Number.isInteger(Number(values.probelength))) {
      errors.probelength = "validation_probelength_integer";
    }

    if (!values.probesensnum) {
      errors.probesensnum = "validation_required_field";
    } else if (!Number.isInteger(Number(values.probesensnum))) {
      errors.probesensnum = "validation_probesensnum_integer";
    } else if (Number(values.probesensnum) > 15) {
      errors.probesensnum = "validation_probesensnum_max";
    }
  }

  // Comments length validation
  if (values.comments && values.comments.length > 50) {
    errors.comments = "validation_comments_length";
  }

  return errors;
};
